<template>
  <div class="container mt-4">
    <!-- Breadcrumb -->
    <b-breadcrumb class="m-3">
      <b-breadcrumb-item href="/"> <i class="fa fa-home" aria-hidden="true"></i> Home</b-breadcrumb-item>
      <b-breadcrumb-item active> {{ getBread(id) }}</b-breadcrumb-item>
    </b-breadcrumb>
    <div class="customCard">      
        <h2 class="text-center pb-3 fs-5 fs-md-5">
        List of Residents ( {{ getBread(id)  }} )
      </h2>
    </div>

    <div v-if="loading" class="text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else-if="error" class="text-center text-danger">
      <p>Error loading data.</p>
    </div>
    <div v-else>
      <div v-if=" id == '-res' && getUserRole('carers') || getUserRole('owners')">
      <button class="btn btn-primary mb-4" @click="showAddModal = true">
        Add Resident
      </button>
      </div>
     
      <div class="row">
  <div
    class="col-12 col-md-6 col-lg-4 mb-4"
    v-for="resident in paginatedResidents"
    :key="resident.id"
  >
    <div class="card h-100 shadow-sm">
      <div class="card-body d-flex flex-column">
        <!-- Name with dynamic link -->
        <h5 class="card-title mb-2">
          <template v-if="id === '-res'">
            <a href="#" @click.prevent="viewEntry(resident)">
              {{ resident.attributes.firstname }} {{ resident.attributes.lastname }}
            </a>
          </template>
          <template v-else-if="id === '-chart'">
            <router-link :to="{ name: 'residentcharting', params: { id: resident.id } }">
              {{ resident.attributes.firstname }} {{ resident.attributes.lastname }}
            </router-link>
          </template>
          <template v-else-if="id === '-vit'">
            <router-link :to="{ name: 'residentvitals', params: { id: resident.id } }">
              {{ resident.attributes.firstname }} {{ resident.attributes.lastname }}
            </router-link>
          </template>
          <template v-else-if="id === '-adl'">
            <router-link :to="{ name: 'residentadl', params: { id: resident.id } }">
              {{ resident.attributes.firstname }} {{ resident.attributes.lastname }}
            </router-link>
          </template>
          <template v-else-if="id === '-ins'">
            <router-link :to="{ name: 'residentinsurances', params: { id: resident.id } }">
              {{ resident.attributes.firstname }} {{ resident.attributes.lastname }}
            </router-link>
          </template>
          <template v-else-if="id === '-prov'">
            <router-link :to="{ name: 'residentproviders', params: { id: resident.id } }">
              {{ resident.attributes.firstname }} {{ resident.attributes.lastname }}
            </router-link>
          </template>
          <template v-else-if="id === '-doc'">
            <router-link :to="{ name: 'residentdocuments', params: { id: resident.id } }">
              {{ resident.attributes.firstname }} {{ resident.attributes.lastname }}
            </router-link>
          </template>
          <template v-else-if="id === '-cont'">
            <router-link :to="{ name: 'residentcontacts', params: { id: resident.id } }">
              {{ resident.attributes.firstname }} {{ resident.attributes.lastname }}
            </router-link>
          </template>
        </h5>

        <!-- Other fields -->
        <p class="mb-1"><strong>Admission Date:</strong> {{ formatDate(resident.attributes.admissiondate) }}</p>
        <p class="mb-1"><strong>Med Cart:</strong> {{ resident.attributes.medcart }}</p>
        <p class="mb-1"><strong>Room #:</strong> {{ resident.attributes.roomnumber }}</p>
        <p class="mb-1"><strong>Expiring Docs:</strong> {{ resident.attributes.documentexpiring }}</p>
        <p class="mb-3"><strong>Status:</strong> {{ resident.attributes.status }}</p>

        <!-- Edit Action -->
        <div class="mt-auto" v-if="id === '-res' && (getUserRole('carers') || getUserRole('editors') || getUserRole('owners'))">
          <a href="#" @click.prevent="editEntry(resident)" class="btn btn-sm btn-outline-primary">Edit</a>
        </div>
      </div>
    </div>
  </div>
</div>



      <div class="d-flex justify-content-between align-items-center flex-wrap mt-3">
        <p>
          Showing {{ startIndex + 1 }} to {{ endIndex }} of
          {{ result.residents.data.length }} entries
        </p>
        <ul class="pagination">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(currentPage - 1)"
              >Prev</a
            >
          </li>
          <li
            class="page-item"
            v-for="page in totalPages"
            :key="page"
            :class="{ active: currentPage === page }"
          >
            <a class="page-link" href="#" @click.prevent="changePage(page)">{{
              page
            }}</a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: currentPage === totalPages }"
          >
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(currentPage + 1)"
              >Next</a
            >
          </li>
        </ul>
      </div>
    </div>

    <!-- Edit Modal -->
    <b-modal
      size="xl"
      v-model="showEditModal"
      :title="
        'Edit Resident - ' +
        (currentResident
          ? currentResident.attributes.firstname +
            ' ' +
            currentResident.attributes.lastname
          : '')
      "
      hide-footer
    >
      <form v-if="currentResident" @submit.prevent="updateEntry">
        <div class="row">
          <div class="d-grid">
            <h5>Basic Information</h5>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="firstName" class="form-label">First Name</label>
              <input
                type="text"
                class="form-control"
                id="firstName"
                v-model="currentResident.attributes.firstname"
                required
              />
            </div>
            <div class="mb-3">
              <label for="lastName" class="form-label">Last Name</label>
              <input
                type="text"
                class="form-control"
                id="lastName"
                v-model="currentResident.attributes.lastname"
                required
              />
            </div>
            <div class="mb-3">
              <label for="nickName" class="form-label">Nick Name</label>
              <input
                type="text"
                class="form-control"
                id="nickName"
                v-model="currentResident.attributes.nickname"
              />
            </div>
            <div class="mb-3">
              <label for="gender" class="form-label">Gender</label>
              <select
                class="form-select"
                id="gender"
                v-model="currentResident.attributes.gender"
              >
                <option value="Female">Female</option>
                <option value="Male">Male</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="dob" class="form-label">Date of Birth</label>
              <input
                type="date"
                class="form-control"
                id="dob"
                v-model="currentResident.attributes.dob"
                required
              />
            </div>
            <div class="mb-3">
              <label for="address" class="form-label">Address</label>
              <input
                type="text"
                class="form-control"
                id="address"
                v-model="currentResident.attributes.address"
              />
            </div>
            <div class="mb-3">
              <label for="race" class="form-label">Race</label>
              <input
                type="text"
                class="form-control"
                id="race"
                v-model="currentResident.attributes.race"
              />
            </div>
            <div class="mb-3">
              <label for="dnr" class="form-label">DNR</label>
              <select
                class="form-select"
                id="dnr"
                v-model="currentResident.attributes.dnr"
              >
                <option value="No">Yes</option>
                <option value="Yes">No</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="dnrtype" class="form-label">DNR Type</label>
              <input
                type="text"
                class="form-control"
                id="dnrtype"
                v-model="currentResident.attributes.dnrtype"
              />
            </div>
            <div class="mb-3">
              <label for="pressuresore" class="form-label">Pressure Sore</label>
              <select
                class="form-select"
                id="pressuresore"
                v-model="currentResident.attributes.pressuresore"
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="admissionDate" class="form-label"
                >Admission Date</label
              >
              <input
                type="date"
                class="form-control"
                id="admissionDate"
                v-model="currentResident.attributes.admissiondate"
                required
              />
            </div>
            <div class="mb-3">
              <label for="specialinstruction" class="form-label"
                >Special Instruction</label
              >
              <textarea
                class="form-control"
                id="specialinstruction"
                v-model="currentResident.attributes.specialinstruction"
              ></textarea>
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="medCart" class="form-label">Med Cart</label>
              <select
                class="form-select"
                id="medCart"
                v-model="currentResident.attributes.medcart"
              >
                <option value="Default">Default</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="roomNumber" class="form-label">Room Number</label>
              <input
                type="text"
                class="form-control"
                id="roomNumber"
                v-model="currentResident.attributes.roomnumber"
                required
              />
            </div>
            <div class="mb-3">
              <label for="allergy" rows="3" class="form-label">Allergy</label>
              <textarea
                class="form-control"
                id="allergy"
                v-model="currentResident.attributes.allergy"
              ></textarea>
            </div>
            <div class="mb-3">
              <label for="diagnosis" class="form-label">Diagnosis</label>
              <textarea
                class="form-control"
                id="diagnosis"
                v-model="currentResident.attributes.diagnosis"
              ></textarea>
            </div>
            <div class="mb-3">
              <label for="diet" class="form-label">Diet</label>
              <textarea
                class="form-control"
                id="diet"
                v-model="currentResident.attributes.diet"
              ></textarea>
            </div>
            <div class="mb-3">
              <label for="phone" class="form-label">Phone</label>
              <input
                type="text"
                class="form-control"
                id="phone"
                v-model="currentResident.attributes.phone"
              />
            </div>
            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input
                type="text"
                class="form-control"
                id="email"
                v-model="currentResident.attributes.email"
              />
            </div>
            <div class="mb-3">
              <label for="hiv" class="form-label">HIV</label>
              <select
                class="form-select"
                id="hiv"
                v-model="currentResident.attributes.hiv"
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="locationfrom" class="form-label">Location From</label>
              <input
                type="text"
                class="form-control"
                id="locationfrom"
                v-model="currentResident.attributes.locationfrom"
              />
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="status" class="form-label">Status</label>
              <select
                class="form-select"
                id="status"
                v-model="currentResident.attributes.status"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="d-grid">
            <h5>Other Information</h5>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="mothername" class="form-label">Mother Name</label>
              <input
                type="text"
                class="form-control"
                id="mothername"
                v-model="currentResident.attributes.mothername"
              />
            </div>
            <div class="mb-3">
              <label for="state" class="form-label">State</label>
              <input
                type="text"
                class="form-control"
                id="state"
                v-model="currentResident.attributes.state"
              />
            </div>
            <div class="mb-3">
              <label for="spousename" class="form-label">Spouse Name</label>
              <input
                type="text"
                class="form-control"
                id="spousename"
                v-model="currentResident.attributes.spousename"
              />
            </div>
            <div class="mb-3">
              <label for="occupation" class="form-label">Occupation</label>
              <input
                type="text"
                class="form-control"
                id="occupation"
                v-model="currentResident.attributes.occupation"
              />
            </div>
            <div class="mb-3">
              <label for="hospital" class="form-label">Hospital</label>
              <input
                type="text"
                class="form-control"
                id="hospital"
                v-model="currentResident.attributes.hospital"
              />
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="fathername" class="form-label">Father Name</label>
              <input
                type="text"
                class="form-control"
                id="fathername"
                v-model="currentResident.attributes.fathername"
              />
            </div>
            <div class="mb-3">
              <label for="countryofbirth" class="form-label"
                >Country of Birth</label
              >
              <input
                type="text"
                class="form-control"
                id="countryofbirth"
                v-model="currentResident.attributes.countryofbirth"
              />
            </div>
            <div class="mb-3">
              <label for="personpayingforcare" class="form-label"
                >Person Paying for Care</label
              >
              <input
                type="text"
                class="form-control"
                id="personpayingforcare"
                v-model="currentResident.attributes.personpayingforcare"
              />
            </div>
            <div class="mb-3">
              <label for="idnumber" class="form-label">ID Number</label>
              <input
                type="text"
                class="form-control"
                id="idnumber"
                v-model="currentResident.attributes.idnumber"
              />
            </div>
            <div class="mb-3">
              <label for="hcs" class="form-label">HCS</label>
              <input
                type="text"
                class="form-control"
                id="hcs"
                v-model="currentResident.attributes.hcs"
              />
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="city" class="form-label">City</label>
              <input
                type="text"
                class="form-control"
                id="city"
                v-model="currentResident.attributes.city"
              />
            </div>
            <div class="mb-3">
              <label for="religion" class="form-label">Religion</label>
              <input
                type="text"
                class="form-control"
                id="religion"
                v-model="currentResident.attributes.religion"
              />
            </div>
            <div class="mb-3">
              <label for="personpayingforcarephone" class="form-label"
                >Person Paying for Care Phone</label
              >
              <input
                type="text"
                class="form-control"
                id="personpayingforcarephone"
                v-model="currentResident.attributes.personpayingforcarephone"
              />
            </div>
            <div class="mb-3">
              <label for="military" class="form-label">Military</label>
              <input
                type="text"
                class="form-control"
                id="military"
                v-model="currentResident.attributes.military"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="d-grid">
            <h5>Identifying Information</h5>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="ssn" class="form-label">SSN #</label>
              <input
                type="text"
                class="form-control"
                id="ssn"
                v-model="currentResident.attributes.ssn"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="maritalstatus" class="form-label"
                >Marital Status</label
              >
              <select
                class="form-select"
                id="maritalstatus"
                v-model="currentResident.attributes.maritalstatus"
              >
                <option value="Single">Single</option>
                <option value="Married">Married</option>
                <option value="Widowed">Widowed</option>
              </select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="referredby" class="form-label">Referred By</label>
              <input
                type="text"
                class="form-control"
                id="referredby"
                v-model="currentResident.attributes.referredby"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="d-grid">
            <h5>Health Information</h5>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="livingwill" class="form-label">Living Will</label>
              <select
                class="form-select"
                id="livingwill"
                v-model="currentResident.attributes.livingwill"
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
                <option value="Not known">Not known</option>
              </select>
            </div>

            <div class="mb-3">
              <label for="codestatus" class="form-label">Code Status</label>
              <select
                class="form-select"
                id="codestatus"
                v-model="currentResident.attributes.codestatus"
              >
                <option value="DNR">DNR</option>
                <option value="CPR">CPR</option>
                <option value="Comfort Care">Comfort Care</option>
                <option value="Limited Code">Limited Code</option>
              </select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="glasses" class="form-label">Glasses</label>
              <select
                class="form-select"
                id="glasses"
                v-model="currentResident.attributes.glasses"
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            <div class="mb-3">
              <label for="mobilitydevice" class="form-label"
                >Mobility Device</label
              >
              <select
                class="form-select"
                id="mobilitydevice"
                v-model="currentResident.attributes.mobilitydevice"
              >
                <option value="None">None</option>
                <option value="Cane">Cane</option>
                <option value="Walker">Walker</option>
                <option value="Wheelchair">Wheelchair</option>
              </select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="denture" class="form-label">Denture</label>
              <select
                class="form-select"
                id="denture"
                v-model="currentResident.attributes.denture"
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
          </div>
        </div>

        <div class="d-grid">
          <button type="submit" class="btn btn-primary">Save changes</button>
        </div>
      </form>

      <div v-if="updateError" class="alert alert-danger mt-3">
        {{ updateError }}
      </div>
    </b-modal>

    <!-- View Modal -->
    <b-modal
      size="xl"
      v-model="showViewModal"
      :title="
        'View Resident - ' +
        (currentResident
          ? currentResident.attributes.firstname +
            ' ' +
            currentResident.attributes.lastname
          : '')
      "
      hide-footer
    >
      <div v-if="currentResident">
        <div class="row">
          <div class="d-grid">
            <h5>Basic Information</h5>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">First Name:</strong>
              <span>{{ currentResident.attributes.firstname }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Last Name:</strong>
              <span>{{ currentResident.attributes.lastname }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Nick Name:</strong>
              <span>{{ currentResident.attributes.nickname }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Gender:</strong>
              <span>{{ currentResident.attributes.gender }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Date of Birth:</strong>
              <span>{{ currentResident.attributes.dob }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Address:</strong>
              <span>{{ currentResident.attributes.address }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Race:</strong>
              <span>{{ currentResident.attributes.race }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">DNR:</strong>
              <span>{{ currentResident.attributes.dnr }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">DNR Type:</strong>
              <span>{{ currentResident.attributes.dnrtype }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Pressure Sore:</strong>
              <span>{{ currentResident.attributes.pressuresore }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Admission Date:</strong>
              <span>{{ currentResident.attributes.admissiondate }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Special Instruction:</strong>
              <span>{{ currentResident.attributes.specialinstruction }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Med Cart:</strong>
              <span>{{ currentResident.attributes.medcart }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Room Number:</strong>
              <span>{{ currentResident.attributes.roomnumber }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Allergy:</strong>
              <span>{{ currentResident.attributes.allergy }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Diagnosis:</strong>
              <span>{{ currentResident.attributes.diagnosis }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Diet:</strong>
              <span>{{ currentResident.attributes.diet }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Phone:</strong>
              <span>{{ currentResident.attributes.phone }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Email:</strong>
              <span>{{ currentResident.attributes.email }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">HIV:</strong>
              <span>{{ currentResident.attributes.hiv }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Location From:</strong>
              <span>{{ currentResident.attributes.locationfrom }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Status:</strong>
              <span>{{ currentResident.attributes.status }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="d-grid">
            <h5>Other Information</h5>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Mother Name:</strong>
              <span>{{ currentResident.attributes.mothername }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">State:</strong>
              <span>{{ currentResident.attributes.state }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Spouse Name:</strong>
              <span>{{ currentResident.attributes.spousename }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Occupation:</strong>
              <span>{{ currentResident.attributes.occupation }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Hospital:</strong>
              <span>{{ currentResident.attributes.hospital }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Father Name:</strong>
              <span>{{ currentResident.attributes.fathername }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Country of Birth:</strong>
              <span>{{ currentResident.attributes.countryofbirth }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Person Paying for Care:</strong>
              <span>{{ currentResident.attributes.personpayingforcare }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">ID Number:</strong>
              <span>{{ currentResident.attributes.idnumber }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">HCS:</strong>
              <span>{{ currentResident.attributes.hcs }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">City:</strong>
              <span>{{ currentResident.attributes.city }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Religion:</strong>
              <span>{{ currentResident.attributes.religion }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Person Paying for Care Phone:</strong>
              <span>{{
                currentResident.attributes.personpayingforcarephone
              }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Military:</strong>
              <span>{{ currentResident.attributes.military }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="d-grid">
            <h5>Identifying Information</h5>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">SSN #:</strong>
              <span>{{ currentResident.attributes.ssn }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Marital Status:</strong>
              <span>{{ currentResident.attributes.maritalstatus }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Referred By:</strong>
              <span>{{ currentResident.attributes.referredby }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="d-grid">
            <h5>Health Information</h5>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Living Will:</strong>
              <span>{{ currentResident.attributes.livingwill }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Code Status:</strong>
              <span>{{ currentResident.attributes.codestatus }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Glasses:</strong>
              <span>{{ currentResident.attributes.glasses }}</span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Mobility Device:</strong>
              <span>{{ currentResident.attributes.mobilitydevice }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Denture:</strong>
              <span>{{ currentResident.attributes.denture }}</span>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Add Modal -->
    <b-modal size="xl" v-model="showAddModal" title="Add Resident" hide-footer>
      <form @submit.prevent="addEntry">
        <div class="row">
          <div class="d-grid">
            <h5>Basic Information</h5>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="firstName" class="form-label">First Name</label>
              <input
                type="text"
                class="form-control"
                id="firstName"
                v-model="newResident.firstname"
                required
              />
            </div>
            <div class="mb-3">
              <label for="lastName" class="form-label">Last Name</label>
              <input
                type="text"
                class="form-control"
                id="lastName"
                v-model="newResident.lastname"
                required
              />
            </div>
            <div class="mb-3">
              <label for="nickName" class="form-label">Nick Name</label>
              <input
                type="text"
                class="form-control"
                id="nickName"
                v-model="newResident.nickname"
              />
            </div>
            <div class="mb-3">
              <label for="gender" class="form-label">Gender</label>
              <select
                class="form-select"
                id="gender"
                v-model="newResident.gender"
              >
                <option value="Female">Female</option>
                <option value="Male">Male</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="dob" class="form-label">Date of Birth</label>
              <input
                type="date"
                class="form-control"
                id="dob"
                v-model="newResident.dob"
                required
              />
            </div>
            <div class="mb-3">
              <label for="address" class="form-label">Address</label>
              <input
                type="text"
                class="form-control"
                id="address"
                v-model="newResident.address"
              />
            </div>
            <div class="mb-3">
              <label for="race" class="form-label">Race</label>
              <input
                type="text"
                class="form-control"
                id="race"
                v-model="newResident.race"
              />
            </div>
            <div class="mb-3">
              <label for="dnr" class="form-label">DNR</label>
              <select class="form-select" id="dnr" v-model="newResident.dnr">
                <option value="No">Yes</option>
                <option value="Yes">No</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="dnrtype" class="form-label">DNR Type</label>
              <input
                type="text"
                class="form-control"
                id="dnrtype"
                v-model="newResident.dnrtype"
              />
            </div>
            <div class="mb-3">
              <label for="pressuresore" class="form-label">Pressure Sore</label>
              <select
                class="form-select"
                id="pressuresore"
                v-model="newResident.pressuresore"
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="admissionDate" class="form-label"
                >Admission Date</label
              >
              <input
                type="date"
                class="form-control"
                id="admissionDate"
                v-model="newResident.admissiondate"
                required
              />
            </div>
            <div class="mb-3">
              <label for="specialinstruction" class="form-label"
                >Special Instruction</label
              >
              <textarea
                class="form-control"
                id="specialinstruction"
                v-model="newResident.specialinstruction"
              ></textarea>
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="medCart" class="form-label">Med Cart</label>
              <select
                class="form-select"
                id="medCart"
                v-model="newResident.medcart"
              >
                <option value="Default">Default</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="roomNumber" class="form-label">Room Number</label>
              <input
                type="text"
                class="form-control"
                id="roomNumber"
                v-model="newResident.roomnumber"
                required
              />
            </div>
            <div class="mb-3">
              <label for="allergy" rows="3" class="form-label">Allergy</label>
              <textarea
                class="form-control"
                id="allergy"
                v-model="newResident.allergy"
              ></textarea>
            </div>
            <div class="mb-3">
              <label for="diagnosis" class="form-label">Diagnosis</label>
              <textarea
                class="form-control"
                id="diagnosis"
                v-model="newResident.diagnosis"
              ></textarea>
            </div>
            <div class="mb-3">
              <label for="diet" class="form-label">Diet</label>
              <textarea
                class="form-control"
                id="diet"
                v-model="newResident.diet"
              ></textarea>
            </div>
            <div class="mb-3">
              <label for="phone" class="form-label">Phone</label>
              <input
                type="text"
                class="form-control"
                id="phone"
                v-model="newResident.phone"
              />
            </div>
            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input
                type="text"
                class="form-control"
                id="email"
                v-model="newResident.email"
              />
            </div>
            <div class="mb-3">
              <label for="hiv" class="form-label">HIV</label>
              <select class="form-select" id="hiv" v-model="newResident.hiv">
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="locationfrom" class="form-label">Location From</label>
              <input
                type="text"
                class="form-control"
                id="locationfrom"
                v-model="newResident.locationfrom"
              />
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="status" class="form-label">Status</label>
              <select
                class="form-select"
                id="status"
                v-model="newResident.status"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="d-grid">
            <h5>Other Information</h5>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="mothername" class="form-label">Mother Name</label>
              <input
                type="text"
                class="form-control"
                id="mothername"
                v-model="newResident.mothername"
              />
            </div>
            <div class="mb-3">
              <label for="state" class="form-label">State</label>
              <input
                type="text"
                class="form-control"
                id="state"
                v-model="newResident.state"
              />
            </div>
            <div class="mb-3">
              <label for="spousename" class="form-label">Spouse Name</label>
              <input
                type="text"
                class="form-control"
                id="spousename"
                v-model="newResident.spousename"
              />
            </div>
            <div class="mb-3">
              <label for="occupation" class="form-label">Occupation</label>
              <input
                type="text"
                class="form-control"
                id="occupation"
                v-model="newResident.occupation"
              />
            </div>
            <div class="mb-3">
              <label for="hospital" class="form-label">Hospital</label>
              <input
                type="text"
                class="form-control"
                id="hospital"
                v-model="newResident.hospital"
              />
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="fathername" class="form-label">Father Name</label>
              <input
                type="text"
                class="form-control"
                id="fathername"
                v-model="newResident.fathername"
              />
            </div>
            <div class="mb-3">
              <label for="countryofbirth" class="form-label"
                >Country of Birth</label
              >
              <input
                type="text"
                class="form-control"
                id="countryofbirth"
                v-model="newResident.countryofbirth"
              />
            </div>
            <div class="mb-3">
              <label for="personpayingforcare" class="form-label"
                >Person Paying for Care</label
              >
              <input
                type="text"
                class="form-control"
                id="personpayingforcare"
                v-model="newResident.personpayingforcare"
              />
            </div>
            <div class="mb-3">
              <label for="idnumber" class="form-label">ID Number</label>
              <input
                type="text"
                class="form-control"
                id="idnumber"
                v-model="newResident.idnumber"
              />
            </div>
            <div class="mb-3">
              <label for="hcs" class="form-label">HCS</label>
              <input
                type="text"
                class="form-control"
                id="hcs"
                v-model="newResident.hcs"
              />
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="city" class="form-label">City</label>
              <input
                type="text"
                class="form-control"
                id="city"
                v-model="newResident.city"
              />
            </div>
            <div class="mb-3">
              <label for="religion" class="form-label">Religion</label>
              <input
                type="text"
                class="form-control"
                id="religion"
                v-model="newResident.religion"
              />
            </div>
            <div class="mb-3">
              <label for="personpayingforcarephone" class="form-label"
                >Person Paying for Care Phone</label
              >
              <input
                type="text"
                class="form-control"
                id="personpayingforcarephone"
                v-model="newResident.personpayingforcarephone"
              />
            </div>
            <div class="mb-3">
              <label for="military" class="form-label">Military</label>
              <input
                type="text"
                class="form-control"
                id="military"
                v-model="newResident.military"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="d-grid">
            <h5>Identifying Information</h5>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="ssn" class="form-label">SSN #</label>
              <input
                type="text"
                class="form-control"
                id="ssn"
                v-model="newResident.ssn"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="maritalstatus" class="form-label"
                >Marital Status</label
              >
              <select
                class="form-select"
                id="maritalstatus"
                v-model="newResident.maritalstatus"
              >
                <option value="Single">Single</option>
                <option value="Married">Married</option>
                <option value="Widowed">Widowed</option>
              </select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="referredby" class="form-label">Referred By</label>
              <input
                type="text"
                class="form-control"
                id="referredby"
                v-model="newResident.referredby"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="d-grid">
            <h5>Health Information</h5>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="livingwill" class="form-label">Living Will</label>
              <select
                class="form-select"
                id="livingwill"
                v-model="newResident.livingwill"
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
                <option value="Not known">Not known</option>
              </select>
            </div>

            <div class="mb-3">
              <label for="codestatus" class="form-label">Code Status</label>
              <select
                class="form-select"
                id="codestatus"
                v-model="newResident.codestatus"
              >
                <option value="DNR">DNR</option>
                <option value="CPR">CPR</option>
                <option value="Comfort Care">Comfort Care</option>
                <option value="Limited Code">Limited Code</option>
              </select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="glasses" class="form-label">Glasses</label>
              <select
                class="form-select"
                id="glasses"
                v-model="newResident.glasses"
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            <div class="mb-3">
              <label for="mobilitydevice" class="form-label"
                >Mobility Device</label
              >
              <select
                class="form-select"
                id="mobilitydevice"
                v-model="newResident.mobilitydevice"
              >
                <option value="None">None</option>
                <option value="Cane">Cane</option>
                <option value="Walker">Walker</option>
                <option value="Wheelchair">Wheelchair</option>
              </select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="denture" class="form-label">Denture</label>
              <select
                class="form-select"
                id="denture"
                v-model="newResident.denture"
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
          </div>
        </div>

        <div class="d-grid">
          <button type="submit" class="btn btn-primary">Add Resident</button>
        </div>
      </form>

      <div v-if="addError" class="alert alert-danger mt-3">
        {{ addError }}
      </div>
    </b-modal>
  </div>
</template>

<script>
import { useQuery, useMutation } from "@vue/apollo-composable";
import {
  GET_RESIDENTS,
  CREATE_RESIDENT,
  UPDATE_RESIDENT,
} from "../hooks/queries";
import { ref } from "vue";

import { getUserRole, getBread } from "@/components/values";

export default {
  name: "App",
  
  setup() {
    //const { result, loading, error, refetch } = useQuery(GET_RESIDENTS);
    const { result, loading, error, refetch } = useQuery(GET_RESIDENTS, null, {
       fetchPolicy: 'network-only',
      });
    const { mutate: updateResident } = useMutation(UPDATE_RESIDENT);
    const { mutate: createResident } = useMutation(CREATE_RESIDENT);
    const showEditModal = ref(false);
    const showAddModal = ref(false);
    const showViewModal = ref(false);
    const currentResident = ref(null);
    const updateError = ref(null);
    const addError = ref(null);

    const newResident = ref({
      firstname: "",
      lastname: "",
      nickname: "",
      dob: "",
      gender: "",
      address: "",
      race: "",
      dnr: "",
      dnrtype: "",
      specialinstruction: "",
      pressuresore: "",
      admissiondate: "",
      medcart: "Default",
      roomnumber: "",
      allergy: "",
      diagnosis: "",
      diet: "",
      phone: "",
      email: "",
      hiv: "",
      locationfrom: "",
      mothername: "",
      fathername: "",
      city: "",
      state: "",
      countryofbirth: "",
      religion: "",
      spousename: "",
      personpayingforcare: "",
      personpayingforcarephone: "",
      occupation: "",
      idnumber: "",
      military: "",
      hospital: "",
      hcs: "",
      ssn: "",
      maritalstatus: "",
      referredby: "",
      livingwill: "",
      glasses: "",
      denture: "",
      codestatus: "",
      mobilitydevice: "",
      status: "Active",
      publishedAt: new Date().toISOString()
    });

    const addEntry = async () => {
      addError.value = null;
      //console.log(newResident.value);
      try {
        await createResident({
          data: {
            firstname: newResident.value.firstname,
            lastname: newResident.value.lastname,
            nickname: newResident.value.nickname,
            dob: newResident.value.dob,
            gender: newResident.value.gender,
            address: newResident.value.address,
            race: newResident.value.race,
            dnr: newResident.value.dnr,
            dnrtype: newResident.value.dnrtype,
            specialinstruction: newResident.value.specialinstruction,
            pressuresore: newResident.value.pressuresore,
            admissiondate: newResident.value.admissiondate,
            medcart: newResident.value.medcart,
            roomnumber: newResident.value.roomnumber,
            allergy: newResident.value.allergy,
            diagnosis: newResident.value.diagnosis,
            diet: newResident.value.diet,
            phone: newResident.value.phone,
            email: newResident.value.email,
            hiv: newResident.value.hiv,
            locationfrom: newResident.value.locationfrom,
            mothername: newResident.value.mothername,
            fathername: newResident.value.fathername,
            city: newResident.value.city,
            state: newResident.value.state,
            countryofbirth: newResident.value.countryofbirth,
            religion: newResident.value.religion,
            spousename: newResident.value.spousename,
            personpayingforcare: newResident.value.personpayingforcare,
            personpayingforcarephone:
              newResident.value.personpayingforcarephone,
            occupation: newResident.value.occupation,
            idnumber: newResident.value.idnumber,
            military: newResident.value.military,
            hospital: newResident.value.hospital,
            hcs: newResident.value.hcs,
            ssn: newResident.value.ssn,
            maritalstatus: newResident.value.maritalstatus,
            referredby: newResident.value.referredby,
            livingwill: newResident.value.livingwill,
            glasses: newResident.value.glasses,
            denture: newResident.value.denture,
            codestatus: newResident.value.codestatus,
            mobilitydevice: newResident.value.mobilitydevice,
            status: newResident.value.status,
            publishedAt: new Date().toISOString()
          },
        });
        showAddModal.value = false;
        newResident.value = {
          firstname: "",
          lastname: "",
          nickname: "",
          dob: "",
          gender: "",
          address: "",
          race: "",
          dnr: "",
          dnrtype: "",
          specialinstruction: "",
          pressuresore: "",
          admissiondate: "",
          medcart: "",
          roomnumber: "",
          allergy: "",
          diagnosis: "",
          diet: "",
          phone: "",
          email: "",
          hiv: "",
          locationfrom: "",
          mothername: "",
          fathername: "",
          city: "",
          state: "",
          countryofbirth: "",
          religion: "",
          spousename: "",
          personpayingforcare: "",
          personpayingforcarephone: "",
          occupation: "",
          idnumber: "",
          military: "",
          hospital: "",
          hcs: "",
          ssn: "",
          maritalstatus: "",
          referredby: "",
          livingwill: "",
          glasses: "",
          denture: "",
          codestatus: "",
          mobilitydevice: "",
          status: "Active",
        };
        await refetch();  // Refetch the list of residents after adding a new one
      } catch (e) {
        //console.error("Error adding entry:", e);
        addError.value = `Failed to add resident. Please try again.}`;
      }
    };

    const formatDate = (date) => {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString(undefined, options);
    };

    const editEntry = (resident) => {
      //currentResident.value = { ...resident }; // Copy resident to avoid directly modifying the original data
      currentResident.value = JSON.parse(JSON.stringify(resident)); // Create a deep copy of the resident object
      showEditModal.value = true;
    };

    const viewEntry = (resident) => {
      currentResident.value = JSON.parse(JSON.stringify(resident)); // Create a deep copy of the resident object
      showViewModal.value = true;
    };

    const updateEntry = async () => {
      updateError.value = null; // Reset the error message
      try {
        await updateResident({
          id: currentResident.value.id,
          data: {
            firstname: currentResident.value.attributes.firstname,
            lastname: currentResident.value.attributes.lastname,
            nickname: currentResident.value.attributes.nickname,
            dob: currentResident.value.attributes.dob,
            gender: currentResident.value.attributes.gender,
            address: currentResident.value.attributes.address,
            race: currentResident.value.attributes.race,
            dnr: currentResident.value.attributes.dnr,
            dnrtype: currentResident.value.attributes.dnrtype,
            specialinstruction:
              currentResident.value.attributes.specialinstruction,
            pressuresore: currentResident.value.attributes.pressuresore,
            admissiondate: currentResident.value.attributes.admissiondate,
            medcart: currentResident.value.attributes.medcart,
            roomnumber: currentResident.value.attributes.roomnumber,
            allergy: currentResident.value.attributes.allergy,
            diagnosis: currentResident.value.attributes.diagnosis,
            diet: currentResident.value.attributes.diet,
            phone: currentResident.value.attributes.phone,
            email: currentResident.value.attributes.email,
            hiv: currentResident.value.attributes.hiv,
            locationfrom: currentResident.value.attributes.locationfrom,
            mothername: currentResident.value.attributes.mothername,
            fathername: currentResident.value.attributes.fathername,
            city: currentResident.value.attributes.city,
            state: currentResident.value.attributes.state,
            countryofbirth: currentResident.value.attributes.countryofbirth,
            religion: currentResident.value.attributes.religion,
            spousename: currentResident.value.attributes.spousename,
            personpayingforcare:
              currentResident.value.attributes.personpayingforcare,
            personpayingforcarephone:
              currentResident.value.attributes.personpayingforcarephone,
            occupation: currentResident.value.attributes.occupation,
            idnumber: currentResident.value.attributes.idnumber,
            military: currentResident.value.attributes.military,
            hospital: currentResident.value.attributes.hospital,
            hcs: currentResident.value.attributes.hcs,
            ssn: currentResident.value.attributes.ssn,
            maritalstatus: currentResident.value.attributes.maritalstatus,
            referredby: currentResident.value.attributes.referredby,
            livingwill: currentResident.value.attributes.livingwill,
            glasses: currentResident.value.attributes.glasses,
            denture: currentResident.value.attributes.denture,
            codestatus: currentResident.value.attributes.codestatus,
            mobilitydevice: currentResident.value.attributes.mobilitydevice,
            status: currentResident.value.attributes.status,
          },
        });
        //console.log("Updated entry:", currentResident.value);
        showEditModal.value = false;
      } catch (error) {
        //console.error("Error updating entry:", error);
        updateError.value = "Failed to update resident. Please try again.";
      }
    };

    return {
      result,
      loading,
      error,
      formatDate,
      showEditModal,
      showAddModal,
      showViewModal,
      currentResident,
      newResident,
      editEntry,
      viewEntry,
      updateEntry,
      addEntry,
      updateError,
      addError,   
      getUserRole,     
      getBread,          
    };
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      id: this.$route.params.id    
    };
  },
  watch: {
    '$route.params.id'(newId) {
      this.residentId = newId;
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.result.residents.data.length / this.itemsPerPage);
    },
    paginatedResidents() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.result.residents.data.slice(start, start + this.itemsPerPage);
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return Math.min(
        this.startIndex + this.itemsPerPage,
        this.result.residents.data.length
      );
    },
  },
  methods: {
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
   
  },
};
</script>

<style scoped>
.container {
  max-width: 80%;
}

.d-grid {
  background-color: #e8e8e8;
  margin-bottom: 20px;
}

.text-center {
  text-align: center;
}
.spinner-border {
  margin-top: 20px;
}
.pagination {
  margin: 0;
}
.breadcrumb {
  background-color: transparent;
}
/* Remove underline from breadcrumb links */
.breadcrumb-item a {
  text-decoration: none;
}

/* Optionally add a hover effect */
.breadcrumb-item a:hover {
  text-decoration: underline;
}
/* Change the default separator to '>' */
.breadcrumb-item + .breadcrumb-item::before {
  content: ">";
  color: #6c757d; /* Customize the color of the separator */
}

</style>
